import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../state/actions";
import Layout from "../../components/layout/Layout";
import PreloaderBg from "../../components/shared/preloaderBg/PreloaderBg";
import MenuLeft from "../../components/shared/menuLeft/MenuLeft";
import PackageDetail from "../../components/packageDetail/PackageDetail";
import Error404Detail from "../../components/error404Detail/Error404Detail";
//import { gtmProductDetail } from "../../gtm/gtm";

const Package = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentPage = useSelector((state) => state.currentPage);
  const currentLang = useSelector((state) => state.currentPage.currentLang);
  const siteParams = useSelector((state) => state.siteParams);
  const user = useSelector((state) => state.user);
  const catalogue = useSelector((state) => state.catalogue);
  const packages = useSelector((state) => state.packages);
  const isFetching = currentPage.isFetching;
  const isLogging = currentPage.isLogging;

  useEffect(() => {
    console.log("Package");

    // recupero struttura percorso da url (per via del back dal browser, devo sempre recuperare i dati via url)
    const pathNodes = location.pathname.split("/").filter((val) => val !== "");

    const reti_urlseo = pathNodes[0];
    const parent_product_category_urlseo = pathNodes[1];
    const product_category_urlseo = pathNodes[2];
    const product_urlseo = pathNodes[3].replace(".html", "");

    const package_id = product_urlseo.split("-idpak").pop();

    console.log(
      reti_urlseo,
      parent_product_category_urlseo,
      product_category_urlseo,
      product_urlseo,
      package_id
    );

    // controllo per pagina 404, se currentPage.routeName === 'error404Detail' vuol dire che ho inserito un url sbagliato, restituisco la pagina 404
    if (currentPage.routeName === "error404Detail") {
      // recupero pagina 404
      const wrongPage404 =
        reti_urlseo +
        "/" +
        parent_product_category_urlseo +
        "/" +
        product_category_urlseo +
        "/" +
        product_urlseo +
        ".html";
      setTimeout(
        () =>
          dispatch(
            allActions.staticDetailActions.fetchError404Detail(
              currentPage.currentLang,
              user?.userData?.id,
              wrongPage404
            )
          ),
        50
      );
    } else {
      const parent_product_category_id = Object.keys(catalogue)
        .filter(
          (key) => catalogue[key].urlSeo === parent_product_category_urlseo
        )
        .toString();
      const parent_product_category = catalogue[parent_product_category_id];

      let packageitem = null;
      if (package_id) {
        // controllo nello store se ho già recuperato tutti i dati del prodotto (isFetched = true), altrimenti eseguo action creator
        packageitem = packages[package_id];
      }

      // ho il prodotto, setto i metatags ed invio dati a GTM
      if (packageitem) {
        // setto i metatags

        document.title = packageitem.metaTitle;
        document.getElementsByTagName("META")[2].content = packageitem.metaDesc;

        // gtm detail prodotto
        const nomeProdotto = packageitem.titolo;
        const codiceProdotto = packageitem.id;
        const imponibile = parseFloat(packageitem.prezzoOriginale).toFixed(2);
        const sconto = 0;
        const prezzoScontato = parseFloat(packageitem.prezzo).toFixed(2);
        const categoria = parent_product_category.detail.titolo;

        const productData = {
          nomeProdotto,
          codiceProdotto,
          imponibile,
          sconto,
          prezzoScontato,
        };

        // gtm productDetail
        const gtmSuffix = `gtm_code${currentLang}`;
        const currentGTMTAG = siteParams[gtmSuffix];
        /*
		gtmProductDetail({
          productData: productData,
          categoryName: categoria,
          isGtmEnabled: currentGTMTAG !== null ? true : false,
        });
		*/
      }

      // recupero sempre il prodotto dalle API per via della scontistica utente quando fa login o logout (creava solo problemi tirar su la versione da loadProductDetail)
      setTimeout(
        () =>
          dispatch(
            allActions.packageDetailActions.fetchPackageDetail(
              currentPage.currentLang,
              user?.userData?.id,
              product_urlseo
            )
          ),
        50
      );
    }
  }, [location, isLogging]);

  const isPage404 =
    currentPage.routeName === "error404Detail" ? (
      <Error404Detail />
    ) : (
      <PackageDetail />
    );

  return (
    <Layout>
      <div className="container mx-auto">
        <PreloaderBg showPreloader={isFetching} />
        <div className="grid grid-cols-60">
          <MenuLeft />
          {isPage404}
        </div>
      </div>
    </Layout>
  );
};

export default Package;
